import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/form/home/home.component';
import { AuthGuardService } from './authentication/auth-guard.service';
import { EditComponent } from './components/form/edit/edit.component';

import { InstallComponent } from './components/system/install/install.component';
//import { FrameRedirectComponent } from './authentication/frame-redirect/frame-redirect.component';

const appRoutes: Routes = [
    { path: '', component: HomeComponent, canActivate: [AuthGuardService] },

    { path: 'installpage', component: InstallComponent },
    { path: 'graphs', component: HomeComponent, canActivate: [AuthGuardService] },
    { path: 'edit', component: EditComponent, canActivate: [AuthGuardService] }
];

@NgModule({
    imports: [
        RouterModule.forRoot(
            appRoutes,
            //{ enableTracing: true } // <-- debugging purposes only
            {
                // useHash: true,
                scrollPositionRestoration: 'enabled',
                anchorScrolling: 'enabled'
            }
        ),
    ],
    exports: [
        RouterModule
    ],
    providers: [
    ]
})

export class AppRoutingModule { }